/* global window */

import axios from 'axios';
import qs from 'qs';
import store from '../reducers/store';

class ConferenceService {
  getConferences(query) {
    return axios({
      method: 'GET',
      url: process.env.API_URL + 'conferences/',
      params: query,
      paramsSerializer: (serializable) => {
        return qs.stringify(serializable, { encode: false });
      },
      headers: {
        Authorization: window.localStorage.getItem('access_token'),
        'X-Org': window.localStorage.getItem('organization_id'),
        'X-Refresh-Token': window.localStorage.getItem('refresh_token'),
        'X-Username': window.localStorage.getItem('username'),
      },
    }).then((response) => {
      store.dispatch({ type: 'UPDATE_CONFERENCES', conferences: response.data.data });

      return response.data.data;
    });
  }
}

export default new ConferenceService();



// WEBPACK FOOTER //
// ./src/services/conferenceService.js